import { create } from 'zustand';

const useGameStore = create((set, get) => ({
  // Game state
  isPlaying: false,
  isPaused: false,
  isGameOver: false,
  showInstructions: true,
  
  // Game metrics
  score: 0,
  survivalTime: 0,
  complexity: 0,
  startTime: null,
  
  // Drawing data
  drawnPaths: [],
  currentPath: null,
  
  // HUD state
  hudMinimized: false,
  hudPosition: { x: 0, y: 0 },
  
  // Complexity sensitivity (1.0 = normal, 2.0 = double speed, 0.5 = half speed)
  complexitySensitivity: 1.0,
  
  // Actions
  startGame: () => set({ 
    isPlaying: true, 
    isPaused: false,
    isGameOver: false,
    showInstructions: false,
    score: 0, 
    survivalTime: 0, 
    complexity: 0,
    drawnPaths: [],
    currentPath: null,
    startTime: Date.now()
  }),
  
  pauseGame: () => set({ isPaused: true }),
  
  resumeGame: () => set({ isPaused: false }),
  
  endGame: () => set({ isGameOver: true, isPlaying: false }),
  
  resetGame: () => set({ 
    isPlaying: false,
    isPaused: false,
    isGameOver: false,
    score: 0, 
    survivalTime: 0, 
    complexity: 0,
    drawnPaths: [],
    currentPath: null,
    startTime: null
  }),
  
  updateScore: (delta) => set((state) => ({ 
    score: state.score + delta 
  })),
  
  updateComplexity: (value) => set({ complexity: value }),
  
  updateSurvivalTime: () => {
    const state = get();
    if (state.startTime && state.isPlaying && !state.isPaused) {
      const elapsed = (Date.now() - state.startTime) / 1000;
      set({ survivalTime: elapsed });
    }
  },
  
  addPath: (path) => set((state) => ({ 
    drawnPaths: [...state.drawnPaths, path],
    currentPath: null
  })),
  
  setCurrentPath: (path) => set({ currentPath: path }),
  
  clearCurrentPath: () => set({ currentPath: null }),
  
  hideInstructions: () => set({ showInstructions: false }),
  
  toggleHudMinimized: () => set((state) => ({ hudMinimized: !state.hudMinimized })),
  
  setHudPosition: (position) => set({ hudPosition: position }),
  
  setComplexitySensitivity: (value) => set({ complexitySensitivity: value })
}));

export default useGameStore;